import NewSectionText from './NewSectionText';

export default NewSectionText;
